import { AfterViewInit, Component, ElementRef, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { I18nService } from '../../../../i18n';
import { FormQuestionBaseComponent } from '../../formquestion-base.component';
import { FormHiddenQuestion } from '../../formquestion-hidden';

@Component({
    selector: 'form-hidden-bootstrap',
    templateUrl: './hidden.component.html',
    styleUrls: ['./hidden.component.scss'],
})
export class FormHiddenBootstrapComponent extends FormQuestionBaseComponent implements AfterViewInit {
    @Input() override question: FormHiddenQuestion<any>;
    @Input() override form: UntypedFormGroup;

    constructor(i18nService: I18nService, private el: ElementRef) {
        super(i18nService);
    }

    ngAfterViewInit() {
        if (this.question.onAfterViewInit) {
            this.question.onAfterViewInit(this.el.nativeElement);
        }
        super.afterViewInit(this, this.el);
    }
}
